// Shared "active project" rule for Projects, Tasks, Schedule, Gantt & BOQ selectors.
export const ACTIVE_PROJECT_STATUSES = [
  'active', 'in_progress', 'confirmed', 'delayed',
  'completed_with_snags', 'completed_with_extra_works',
];

export const isActiveProject = (p) =>
  !!p && p.is_active !== false && !p.archived && ACTIVE_PROJECT_STATUSES.includes(p.status || 'in_progress');

// Selectable in BOQ project pickers (excludes archived + rejected only).
export const isSelectableProject = (p) =>
  !!p && p.is_active !== false && !p.archived && p.status !== 'rejected';

export const matchesProjectFilter = (p, filter) => {
  if (filter === 'active') return isActiveProject(p);
  if (filter === 'inactive') return !isActiveProject(p);
  return true;
};
